(ns frontend.view.nev.kyc.process.pep-editor
  (:require
   [common.localization :as loc]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.confirmation.view :as confirmation-modal]
   [frontend.view.modals.dynamic.view :as dynamic-modal]
   [clojure.data :as data]
   [reagent.core :as r]
   [frontend.view.nev.kyc.process-status-views.view-utils :as view-utils]
   [common.schema.entities.workspace.kyc.kyc-utils :as kyc-utils]
   [ui.components.button.view :as button]))

(defn open-pep-editor
  [{:keys [idx existing-pep answers-atom
           question-attribute question-meta
           lang-kw kyc-entity-editor
           process-id kyc-process state-atom
           read-only? mandatory? save!]}]
  (let [peps (get @answers-atom question-attribute)
        idx (or idx (count peps))
        existing-pep (or existing-pep (get peps idx))
        pep-answers (r/atom (or existing-pep {}))
        field-errors-atom (r/atom {})
        pep-template-schema (:data/template question-meta)
        calc-new-peps-answer (fn []
                               (if (and (number? idx)
                                        (>= idx (count peps)))
                                 (concat peps
                                         [(assoc @pep-answers
                                                 :ord
                                                 (count peps))])
                                 (->> peps
                                      (map-indexed (fn [uidx pep]
                                                     (assoc (if (= uidx idx)
                                                              @pep-answers
                                                              pep)
                                                            :ord
                                                            uidx)))
                                      (vec))))]
    (modals/open-modal!
     dynamic-modal/modal-key
     {:title               (loc/tr :add-pep nil lang-kw)
      :render-fn           (partial kyc-entity-editor
                                    {:container-id    (str "PEP-" idx)
                                     :process-id      process-id
                                     :state-atom      state-atom
                                     :answers-atom    pep-answers
                                     :save!           identity
                                     :skip-info?      true
                                     :mandatory?      mandatory?
                                     :read-only?      read-only?
                                     :field-errors-atom field-errors-atom
                                     :template-schema pep-template-schema
                                     :lang-kw         lang-kw})
      :show-button?        (not read-only?)
      :button-text         (loc/tr :save nil lang-kw)
      :custom-validator-fn (fn [_state]
                             (let [[old-only new-only _] (data/diff existing-pep @pep-answers)
                                   changes? (or (seq old-only)
                                                (seq new-only))]
                               (view-utils/modal-validator-tooltip
                                {:lang-kw           lang-kw
                                 :template-schema   pep-template-schema
                                 :answers-atom      pep-answers
                                 :field-errors-atom field-errors-atom
                                 :kyc-process       kyc-process
                                 :changes?          changes?})))
      :on-submit!          (fn [_]
                             (let [updated-peps (calc-new-peps-answer)]
                               (swap! answers-atom assoc question-attribute updated-peps)
                               (save!)))
      :on-before-close!    (fn [close!]
                             (if (= (get @answers-atom question-attribute) (calc-new-peps-answer))
                               (close!)
                               (modals/open-modal!
                                confirmation-modal/modal-key
                                {:body           (loc/tr :confirm-close-kyc-modal-without-saving nil lang-kw)
                                 :confirm-text   (loc/tr :close-without-saving nil lang-kw)
                                 :confirm-icon   ""
                                 :skip-checkbox? true
                                 :on-confirm     #(close!)})))})))

(defn view
  [{:keys [lang-kw question-attribute question-meta answers-atom read-only?
           save!]
    :as   args}]
  (let [peps (get @answers-atom question-attribute)
        pep-schema (:data/template question-meta)
        pep-questions (->> pep-schema
                           kyc-utils/schema-questions
                           (into {}))]
    (if (and read-only?
             (empty? peps))
      [:div.preview
       [:span (loc/tr :no-peps)]]
      [:table.zap-table.zap-table--striped.zap-table--has-footer.zap-table--width-auto
       [:thead
        [:tr
         [:th.zap-table__headline ""]
         [:th.zap-table__headline (or (kyc-utils/localize-question pep-schema :kyc-ubo.pep/name lang-kw)
                                      (kyc-utils/localize-question pep-schema :kyc-ubo.pep/entity-representative-name
                                                                   lang-kw)
                                      (loc/tr :name nil lang-kw))]
         [:th.zap-table__headline (kyc-utils/localize-question pep-schema :kyc-ubo.pep/relationship-to-pep lang-kw)]
         [:th.zap-table__headline]]]
       [:tbody
        (->> peps
             (sort-by :ord)
             (map-indexed
              (fn [idx pep]
                [:tr
                 {:key (str "PEP-" idx "-" (:ord pep))}
                 [:td.zap-table__cell
                  [:i.fal.fa-external-link.clickable
                   {:on-click (fn [_]
                                (open-pep-editor (assoc args
                                                        :idx idx
                                                        :existing-pep pep)))}]]
                 [:td.zap-table__cell (kyc-utils/pep-display-name pep)]
                 [:td.zap-table__cell
                  (when-let [relationship-to-pep (:kyc-ubo.pep/relationship-to-pep pep)]
                    (kyc-utils/localize-option (:kyc-ubo.pep/relationship-to-pep pep-questions)
                                               []
                                               relationship-to-pep
                                               lang-kw))]
                 [:td.zap-table__cell
                  (when-not read-only?
                    [:i.fal.fa-trash-alt.pointer
                     {:on-click (fn [_]
                                  (swap! answers-atom assoc
                                         question-attribute
                                         (concat (take idx peps)
                                                 (drop (inc idx) peps)))
                                  (save!))}])]]))
             (doall))]
       (when-not read-only?
         [:tfoot
          [:tr.zap-table__row
           [:td.zap-table__footer-cell {:col-span "2"}
            [button/primary-solid
             {:on-click (fn [_]
                          (let [idx (count peps)]
                            (open-pep-editor (assoc args
                                                    :idx
                                                    idx))))}
             [:i.fal.fa-plus.pr-2]
             (loc/tr :add-new nil lang-kw)]]]])])))
